import React, { FC } from 'react'

import PlanSectionTitle from '../PlanSectionTitle/PlanSectionTitle'

import { Button } from 'Components'
import { useAppDispatch } from 'ReduxStore/hooks'
import { updateUserSettingsAction } from 'ReduxStore/userSettings'

type Props = {
  menuPlanHidden: boolean
}

const MenuPlanTitle: FC<Props> = ({ menuPlanHidden }) => {
  const dispatch = useAppDispatch()

  const showMenuPlan = (): void => {
    dispatch(updateUserSettingsAction({ menuPlanHidden: false }))
  }

  return (
    <PlanSectionTitle
      title={menuPlanHidden ? 'Einträge aus dem Menüplan' : 'Menüplan'}
      variant="menu"
      action={
        menuPlanHidden ? (
          <Button type="button" theme="secondary-tiny" onClick={showMenuPlan}>
            Menüplan wieder anzeigen
          </Button>
        ) : undefined
      }
    />
  )
}

export default MenuPlanTitle
